// src/hooks/usePartnerAwareNavigate.ts
import { useNavigate, useLocation } from "react-router-dom";
import { useCallback } from "react";

// List your partner base paths
const partnerPrefixes = [
  "/career-accelerator",
  "/seeu",
  "/ucla-bsn",
  "/babson-bca",
];
// TODO: fetched from db

// Helper to remove any trailing slash (except for root "/")
const normalizePath = (path: string) => {
  if (path !== "/" && path.endsWith("/")) {
    return path.slice(0, -1);
  }
  return path;
};

const usePartnerAwareNavigate = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Determine the current partner context, if any.
  const currentPartnerPrefix = partnerPrefixes.find((prefix) =>
    location.pathname.startsWith(prefix)
  );

  // Memoize the navigation function to prevent re-creation on every render.
  const partnerAwareNavigate = useCallback(
    (to: string, options?: any) => {
      let target = to;

      // Only modify if we're in a partner context and the target is an absolute path.
      if (
        currentPartnerPrefix &&
        target.startsWith("/") &&
        !target.startsWith(currentPartnerPrefix)
      ) {
        target = currentPartnerPrefix + target;
      }

      console.log("target", target);
      // Normalize both paths to prevent minor differences from triggering a loop.
      const normalizedTarget = normalizePath(target);
      const normalizedCurrent = normalizePath(location.pathname);

      // If we're already at the target, do nothing.
      if (normalizedTarget === normalizedCurrent) {
        return;
      }

      navigate(target, options);
    },
    [currentPartnerPrefix, location.pathname, navigate]
  );

  return partnerAwareNavigate;
};

export default usePartnerAwareNavigate;
